// extracted by mini-css-extract-plugin
export default {"linkWrap":"linkWrap--7DFeO","image":"image--7DFeO"};